export default __webpack_public_path__ + "static/media/shopping1.53184207.jpg";